import { useEffect, useState } from 'react';
import {
  doc,
  onSnapshot,
  type DocumentData,
  type FirestoreError,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface DocResult<T> {
  data: (T & { id: string }) | null;
  loading: boolean;
  error: FirestoreError | null;
}

export function useDoc<T = DocumentData>(path: string | null): DocResult<T> {
  const [state, setState] = useState<DocResult<T>>({
    data: null,
    loading: !!path,
    error: null,
  });

  useEffect(() => {
    if (!path) {
      setState({ data: null, loading: false, error: null });
      return;
    }
    const ref = doc(db, path);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (!snap.exists()) {
          setState({ data: null, loading: false, error: null });
        } else {
          setState({
            data: { ...(snap.data() as T), id: snap.id },
            loading: false,
            error: null,
          });
        }
      },
      (error) => setState({ data: null, loading: false, error }),
    );
    return unsub;
  }, [path]);

  return state;
}
